import axios from "axios";

import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * postReport
 *
 * User makes a report.
 *
 * @param name Name of the user who reported the incident.
 * @param email Email address of the user who reported the incident.
 * @param message Reporting details.
 * @returns Result of sending the report.
 */

export const postReport = async (
  name: string,
  email: string,
  chatPartner: string,
  message: string
) => {
  const res = await axios.post(getAPIRoot(APIRoutes.post.report), {
    sonic_name: name,
    sonic_email: email,
    sonic_chat_partner: chatPartner,
    sonic_message: message,
  });

  return res.data.result;
};
